// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2SC6Z","requiredAsterisk":"Info_requiredAsterisk__36bkS"};